import { Goal } from '@akin-home/goals';
import { useCallback } from 'react';
import { useUpdateFieldsCommand } from '../../chat/hooks';

export const useUpdateGoalFormCommand = (
  updateGoal: (data: Partial<Goal>) => void
) =>
  useUpdateFieldsCommand(
    useCallback(
      (data: any) => {
        updateGoal(data);
      },
      [updateGoal]
    )
  );
